import React, { useEffect, useState } from 'react';
import { Button, Grid, Paper, TextField, Typography } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddBoxIcon from '@mui/icons-material/AddBox';

//Carrito
//Cambiar cantidad del prod
//Modificar precio


//Ventas
//Filtro mostrarlo en la parte superior (Filter)
//Mandar alerta de que quedan pocos productos




interface Carrito {
    id: number;
    nombre: string;
    precio: number;
    cantidad: number;
    clave: string;
    marca: string;
}

interface Producto {
    id: number;
    clave: string;
    nombre: string;
    precio_venta: number;
    modeloAuto: string;
    marcaProducto: string;
    marcaAuto: string;
    stock: number;
    seccion: string;
    codigo: string;
    stockMinimo?: number;
    stockMaximo?: number;
}


function Venta() {


    const columnsCarrito: GridColDef[] = [
        {
            field: 'id',
            headerName: 'ID',
            type: 'string',
            flex: 1
        },
        {
            field: 'nombre',
            headerName: 'Nombre',
            type: 'string',
            flex: 1
        },
        {
            field: 'precio',
            headerName: 'Precio',
            type: 'number',
            flex: 1
        },
            {

            field: '',
            headerName: 'Eliminar',
            flex: 1,
            pinnable: true,
            renderCell: (params: any) => (
                <Grid>
                    <Button onClick={() => { eliminarCarrito(params) }}><DeleteForeverIcon /></Button>
                </Grid>
            )
        }
        
    ]



    const columns: GridColDef[] = [
        {
            field: 'clave',
            headerName: 'Clave',
            flex: 3,
        },
        {
            field: 'nombre',
            headerName: 'Nombre',
            flex: 2
        },
        {
            field: 'precio_venta',
            headerName: 'Precio',
            type: 'number',
            flex: 2
        },
        {
            field: 'modeloAuto',
            headerName: 'Modelo auto',
            flex: 5,
        },
        {
            field: 'marcaProducto',
            headerName: 'Marca Producto',
            flex: 2,
        },
        {
            field: 'marcaAuto',
            headerName: 'Marca Auto',
            flex: 3,
        },
        {
            field: 'stock',
            headerName: 'Cantidad',
            type: 'number',
            flex: 1
        },
        {
            field: 'seccion',
            headerName: 'Donde se Encuentra',
            flex: 1
        },
        {
            field: 'codigo',
            headerName: 'Codigo de Barras',
            flex: 1
        },
        {
            flex: 4,
            field: '',
            headerName: 'Agregar',
            renderCell: (params: any) => (
                <Grid>
                    {/* <Button color='primary' onClick={() => { Ver(params); }} > <VisibilityIcon /> </Button> */}
                    <Button color='primary' onClick={() => { Agregar(params) }}><AddBoxIcon /></Button>
                </Grid>
            )
        }
    ];

    const [rows, setRows] = useState<Carrito[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [descuento, setDescuento] = useState<string>("0");
    const [status, setStatus] = useState<boolean>(true);
    const [marca, setMarca] = useState<string>("");

    const [statusButton, setstatusButton] = useState<boolean>(false);
    useEffect(() => {
        console.log("sessionStorage.getItem()", sessionStorage.getItem("lugar"));
        getAllProductos();
        return;
    }, []);

    const [open, setOpen] = React.useState(false);


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const calcularTotal = (carritoItems: Carrito[], descuentoValue: string) => {
        let preTotal: Number[] = []
        carritoItems.forEach((d) => {
            preTotal.push(d.precio * d.cantidad)
        })

        const initialValue = 0;
        const sumWithInitial = preTotal.reduce(
            (accumulator, currentValue) => Number(accumulator) + Number(currentValue),
            initialValue
        );
        const finalPrecio = Number(sumWithInitial) - Number(descuentoValue);
        setTotal(finalPrecio);
        return finalPrecio;
    }

    const Agregar = (data: any) => {
        console.log(data);
        const data3: Carrito = { id: data.row.id, nombre: data.row.nombre, precio: data.row.precio_venta, cantidad: 1, clave: data.row.clave, marca: data.row.marcaProducto }

        // Siempre agregar como nueva instancia, sin verificar duplicados
        const newRows = [...rows, data3];
        setRows(newRows);
        
        calcularTotal(newRows, descuento);
    }

    const eliminarCarrito = (data: any) => {

        const idToRemove = data.row.id;
        const indexToRemove = rows.findIndex(item => String(item.id) === String(idToRemove));
        if (indexToRemove === -1) return;
        const nuevo = [...rows.slice(0, indexToRemove), ...rows.slice(indexToRemove + 1)];
        console.log(nuevo);
        setRows(nuevo);
        
        calcularTotal(nuevo, descuento);
    }

    const validaTotal = () => {
        const finalPrecio = calcularTotal(rows, descuento);
        if (finalPrecio <= 0) {
            setstatusButton(true);
        } else {
            setstatusButton(false);
        }
        console.log(finalPrecio);
    }
    const [productos, setProductos] = useState<Producto[]>([]);

    const [clave, setClave] = useState<string>("");

    const [nombre, setNombre] = useState<string>("");

    const [modeloAuto, setModeloAuto] = useState<string>("");

    const [codigo, setCodigo] = useState<string>("");



    const getAllProductos = () => {
        let l: number = Number(sessionStorage.getItem("lugar"))
        console.log("l", l);
        axios({
            method: 'get',
            url: '/getAllProductos.php?lugar=' + l + '',
        })
            .then(function (response) {
                let stringvar = "\n\n\n\t"
                if (response.data === stringvar) {
                    console.log("response", response)
                } else {
                    setProductos(response.data);
                }
            });
    }

    const getProductos = () => {
        let l: number = Number(sessionStorage.getItem("lugar"))
        axios({
            method: 'get',
            url: '/getProductos.php?clave=' + clave + '&nombre=' + nombre + '&modeloAuto=' + modeloAuto + '&codigo=' + codigo + '&marca=' + marca + '&lugar=' + l,
        })
            .then(function (response) {
                let stringvar = '\n\n\n\t'
                console.log("response:", response.data);
                if (response.data === stringvar) {
                    console.log("response", response)
                } else {
                    setProductos(response.data);
                }
            });


    }



    const handleChangeNombre = (data: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = data.target;
        setNombre(value);
        setStatus(false)
    }


    const handleChangeCodigoBarras = (data: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = data.target;
        setCodigo(value);
        setStatus(false)
    }

    const handleChangeMarca = (data: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = data.target;
        setMarca(value);
        setStatus(false)
    }





    const handleChangeDescuento = (data: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = data.target;
        setDescuento(value);
        calcularTotal(rows, value);
    }

    const handleChangeClave = (data: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = data.target;
        setClave(value);
        setStatus(false)
    }

    const handleChangeModeloAuto = (data: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = data.target;
        setModeloAuto(value);
        setStatus(false)
    }

    const vender = async (carritoVenta: any) => {
        let l: number = Number(sessionStorage.getItem("lugar"))
        console.log(l)
        await validaTotal();
        axios.post('/postCarrito.php?lugar=' + l, {
            carritoVenta,
            "total": total,
            "descuento": Number(descuento),
        }).then(function (response) {
            console.log(response);
            getAllProductos();
        });
        handleClose();
        setRows([]);
        console.log("carritoVenta", carritoVenta);

    }
    return (
        <Grid container spacing={2} sx={{ textAlign: 'center' }}>
            <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1.5, sm: 2 }, borderRadius: 3 }}>
                    <Grid container spacing={1.5}>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField fullWidth label={"Clave"} value={clave} onChange={handleChangeClave} onKeyUp={getProductos} />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField fullWidth label={"Nombre"} value={nombre} onChange={handleChangeNombre} onKeyUp={getProductos} />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField fullWidth label={"Modelo Auto"} value={modeloAuto} onChange={handleChangeModeloAuto} onKeyUp={getProductos} />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField fullWidth label={"Marca"} value={marca} onChange={handleChangeMarca} onKeyUp={getProductos} />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField fullWidth label={"Codigo de Barras"} value={codigo} onChange={handleChangeCodigoBarras} onKeyUp={getProductos} />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Button fullWidth variant='contained' color='secondary' onClick={getProductos} disabled={status}>Buscar</Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ width: '100%', height: { xs: 310, md: 360 }, borderRadius: 3, overflow: 'hidden' }}>
                    <DataGrid
                        getRowId={(row: any) => row.id}
                        rows={productos}
                        columns={columns}
                        pageSize={100}
                        rowsPerPageOptions={[100]}
                        experimentalFeatures={{ newEditingApi: true }}
                    />
                </Paper>
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ width: '100%', height: { xs: 260, md: 320 }, borderRadius: 3, overflow: 'hidden' }}>
                    <DataGrid
                        getRowId={(row: any) => row.id}
                        rows={rows}
                        columns={columnsCarrito}
                        pageSize={100}
                        rowsPerPageOptions={[100]}
                        experimentalFeatures={{ newEditingApi: true }}
                    />
                </Paper>
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1.5, sm: 2 }, borderRadius: 3 }}>
                    <Grid container spacing={1.5} alignItems="center">
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth label={"Descuento"} value={descuento} onChange={handleChangeDescuento} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Typography sx={{ color: '#0F172A', fontWeight: 700 }}>Total : $ {total.toString()}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Button fullWidth color='secondary' variant='contained' type='button' onClick={() => {
                                validaTotal();
                                handleClickOpen();
                            }}>Vender</Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Confirmar Venta</DialogTitle>
                <DialogContent>
                    <Typography>
                        Deseas Confirmar la venta por $ {total.toString()}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color='secondary' disabled={statusButton} onClick={() => { vender(rows) }}>Vender</Button>
                    <Button color='primary' onClick={handleClose}>Cancelar</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}

export default Venta;